export * from './infinite-scroll.component';
export * from './infinite-scroll.module';
